// extracted by mini-css-extract-plugin
module.exports = {"hideClose":"unavailable_hideClose__22Wg6","icon":"unavailable_icon__1TGyG","description":"unavailable_description__MDvRg","btnContainer":"unavailable_btnContainer__1AX4o"};